import { useTranslation } from "react-i18next"

function WarningMessage({
    message
}) {

    const [t, i18n] = useTranslation(["global"])

    let content =
        <div>
            <div className="alert alert-warning alert-dismissible" role="alert" key="unique">
            <i className="fa-solid fa-triangle-exclamation"></i> {message}
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>

    return content
}

export default WarningMessage